import { DEFAULT_USER_MEETINGS_SETTINGS } from "src/components";
import { IUserMeetingsSettings, useSettings } from "src/hooks";

const useUserMeetingsSettings = (userGuid: string) => {
  const {
    userMeetingsSettings: { [userGuid]: unsafeSettings },
    updateUserMeetingsSettings,
  } = useSettings();

  const safeSettings: IUserMeetingsSettings = {
    ...DEFAULT_USER_MEETINGS_SETTINGS,
    ...unsafeSettings,
  };

  return {
    settings: safeSettings,
    updateSettings: (updatedSettings: Partial<IUserMeetingsSettings>) => {
      updateUserMeetingsSettings(userGuid, updatedSettings);
    },
  };
};

export { useUserMeetingsSettings };
